import React, { useEffect } from "react";
import PropTypes from "prop-types";
/* Components */
import BlurredNumber from "@/components/CommonForBoth/Blurred/BlurredNumber";
import { Container, Row, Col } from "react-bootstrap";
import Badges from "@/components/CommonForBoth/Badges";
import { Card } from "semantic-ui-react";
/* i18n */
import { connect, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
/* Store */
import { selectAPICallMultiple } from "@ensuro/api-calls-store";
/* Helpers */
import defaultRiskLogo from "@/assets/images/risks-symbol.png";
import { getRiskParams } from "@/helpers/ensuro_helper";
import { addRemoveSub } from "@/helpers/store_helper";
import "./../style.scss";

const makeAPICalls = (rkAddress) => {
  return [
    { apiName: "activePolicies", args: [rkAddress] },
    { apiName: "maturedSurplus", args: [rkAddress] },
    { apiName: "gwp", args: [rkAddress] },
    { apiName: "scr", args: [rkAddress] },
    { apiName: "rmParams", args: [rkAddress] },
  ];
};

const RiskRowMobile = ({ t, risk, idx, jrRoc, srRoc, activePolicies, maturedSurplus, gwp, scr, rmBadges }) => {
  let dispatch = useDispatch();
  const navigate = useNavigate();
  let tags = risk.custom_data?.tags || [];

  const handleCardClick = (address) => {
    navigate(`/risks/${address}`);
  };

  useEffect(() => {
    return addRemoveSub(dispatch, `riskMobile-${risk.address}`, makeAPICalls(risk.address), []);
  }, [dispatch, risk.address]);

  return (
    <Container className="mobile">
      <Card className="card-row card-hover primary-colored" onClick={() => handleCardClick(risk.address)} key={idx}>
        <Container>
          <Row className="table-header">
            <Col xs={12}>
              <Card className="card-inside">
                <strong style={{ color: "black" }}>
                  <span className="logo-sm">
                    <img src={risk.logo || defaultRiskLogo} alt="" height="22" />
                  </span>{" "}
                  {risk.name}
                </strong>
              </Card>
            </Col>
            <Col xs={12} className="align-self-center">
              <Badges tags={tags} badgesData={rmBadges || []} />
            </Col>
            <br />
            <br />
            <Col xs={4}>
              <strong>{t("Active Policies")}</strong>
            </Col>
            <Col xs={3}>
              <strong>{t("GWP")}</strong>
            </Col>
            <Col xs={5}>
              <strong>{t("SCR")}</strong>
            </Col>
            <Col xs={4}>
              <Card className="card-inside" style={{ color: "black" }}>
                <BlurredNumber number={activePolicies} options={{ notation: "standard" }} />
              </Card>
            </Col>
            <Col xs={3}>
              <Card className="card-inside" style={{ color: "black" }}>
                <BlurredNumber number={gwp} options={{ maximumFractionDigits: 2, notation: "compact" }} />
              </Card>
            </Col>
            <Col xs={5}>
              <Card className="card-inside" style={{ color: "black" }}>
                <BlurredNumber number={scr} options={{ maximumFractionDigits: 2, notation: "compact" }} />
              </Card>
            </Col>

            <Col xs={4}>
              <strong>{t("Jr RoC")}</strong>
            </Col>
            <Col xs={3}>
              <strong>{t("Sr RoC")}</strong>
            </Col>
            <Col xs={5}>
              <strong>{t("Surplus/ Deficit")}</strong>
            </Col>

            <Col xs={4}>
              <Card className="card-inside" style={{ color: "black" }}>
                <BlurredNumber
                  number={jrRoc}
                  suffix={"%"}
                  percentage={true}
                  options={{ maximumFractionDigits: 2, notation: "standard" }}
                />
              </Card>
            </Col>
            <Col xs={3}>
              <Card className="card-inside" style={{ color: "black" }}>
                <BlurredNumber
                  number={srRoc}
                  suffix={"%"}
                  percentage={true}
                  options={{ maximumFractionDigits: 2, notation: "standard" }}
                />
              </Card>
            </Col>
            <Col xs={5}>
              <Card className="card-inside" style={{ color: Math.sign(maturedSurplus.value) < 0 ? "red" : "green" }}>
                <BlurredNumber number={maturedSurplus} options={{ maximumFractionDigits: 2, notation: "compact" }} />
              </Card>
            </Col>
          </Row>
        </Container>
      </Card>
    </Container>
  );
};

RiskRowMobile.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = (state, ownProps) => {
  const rkAddress = ownProps.risk.address;
  const [activePolicies, maturedSurplus, gwp, scr, rmParams] = selectAPICallMultiple(
    state.APIReducer,
    makeAPICalls(rkAddress)
  );
  const { jrRoc, srRoc } = getRiskParams(rmParams);
  return { jrRoc, srRoc, activePolicies, maturedSurplus, gwp, scr };
};

export default connect(mapStateToProps)(withTranslation()(RiskRowMobile));
